import React, { useEffect, useState } from "react";
import Iconify from "../../../../layouts/components/iconify/iconify";
import { useAddTaskTodoMutation, useDeleteTaskTodoMutation, useLazyGetAllTaskTodoListQuery, useUpdateTaskTodoMutation } from "../../../../app/services/tasktodoAPI";
import ToastService from "../../../../services/toastService/ToastService";
import SwalAlert from "../../../../services/swalService/SwalService";
import './Todo.scss'

const TodoTestLocal = ({ props, taskId, projectId }) => {
  const { confirm } = SwalAlert();
  const [todos, setTodos] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editedText, setEditedText] = useState("");
  const [newTodoText, setNewTodoText] = useState("");
  const [isAdding, setIsAdding] = useState(false);
  const [isDone] = useState("");

  const [
    getAllTaskTodoList,
    {
      isLoading: isTaskTodoListLoading,
      isSuccess: isTaskTodoSuccess,
      data: isTaskTodoListData,
    },
  ] = useLazyGetAllTaskTodoListQuery();

  const [
    deleteTaskTodo,
    { isSuccess: isTaskTodoDeleted, data: DeleteTaskTodoDeleted },
  ] = useDeleteTaskTodoMutation();

  const [updateTaskTodo, {
    isSuccess: isSuccessUpdateTaskTodo,
    data: updateTaskTodoData }] =
    useUpdateTaskTodoMutation();

  const [
    addTaskTodo,
    { isSuccess: isTaskTodoAdded, data: addTaskTodoData },
  ] = useAddTaskTodoMutation();

  useEffect(() => {
    if (taskId && projectId) {
      getAllTaskTodoList({ taskId, projectId });
    }
  }, [getAllTaskTodoList, taskId, projectId]);

  useEffect(() => {
    if (isTaskTodoSuccess && !isTaskTodoListLoading && isTaskTodoListData) {
      setTodos(isTaskTodoListData);
    }
  }, [isTaskTodoSuccess, isTaskTodoListLoading, isTaskTodoListData]);

  const handleEdit = (todoId, todoText) => {
    setEditingId(todoId);
    setEditedText(todoText);
  };

  const handleSave = (todoId) => {
    setTodos((prevTodos) =>
      prevTodos.map((todo) =>
        todo.taskTodoId === todoId ? { ...todo, todoText: editedText } : todo
      )
    );
    const req = {
      taskTodoId: todoId,
      todoText: editedText,
      isDone: false,
      projectId: projectId,
      taskId: taskId
    }
    updateTaskTodo(req)
    setEditingId(null);
  };

  const handleCancel = () => {
    setEditingId(null);
    setIsAdding(false);
    setNewTodoText("");
  };

  const handleDelete = (taskTodoId) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteTaskTodo(taskTodoId);
      }
    });
  };

  const handleAddTodo = () => {
    setIsAdding(true);
  };


  const handleSaveNewTodo = () => {
    if (newTodoText.trim() !== "") {
      // if (!props.selectedId) { }
      const requestData = {
        todoText: newTodoText,
        projectId: projectId,
        isDone: isDone ? true : false,
        taskId: taskId
      }
      addTaskTodo(requestData);
      setTodos((prevTodos) => [...prevTodos, requestData]);
    }
    setIsAdding(false);
    setNewTodoText("");
  };


  const handleToggleCheckbox = (todo) => {
    const updatedTodo = {
      taskTodoId: todo.taskTodoId,
      todoText: todo.todoText,
      isDone: !todo.isDone,
      projectId: projectId,
      taskId: taskId,
    };
    updateTaskTodo(updatedTodo);
    setTodos((prevTodos) =>
      prevTodos.map((t) =>
        t.taskTodoId === todo.taskTodoId ? { ...t, isDone: !t.isDone } : t
      )
    );
  };

  useEffect(() => {
    if (isTaskTodoDeleted && DeleteTaskTodoDeleted) {
      if (DeleteTaskTodoDeleted.errorMessage.includes("exists")) {
        ToastService.warning(DeleteTaskTodoDeleted.errorMessage);
        return;
      } else {
        ToastService.success(DeleteTaskTodoDeleted.errorMessage);
        getAllTaskTodoList({ taskId, projectId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTaskTodoDeleted, DeleteTaskTodoDeleted]);

  useEffect(() => {
    if (isSuccessUpdateTaskTodo && updateTaskTodoData) {
      if (updateTaskTodoData.errorMessage && updateTaskTodoData.errorMessage.includes("exists")) {
        ToastService.warning(updateTaskTodoData.errorMessage);
        return;
      } else {
        ToastService.success(updateTaskTodoData.errorMessage || "Task updated successfully!");
        getAllTaskTodoList({ taskId, projectId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessUpdateTaskTodo, updateTaskTodoData]);


  useEffect(() => {
    if (isTaskTodoAdded && addTaskTodoData) {
      if (addTaskTodoData.errorMessage.includes("exists")) {
        ToastService.warning(addTaskTodoData.errorMessage);
        return;
      }
      else {
        ToastService.success(addTaskTodoData.errorMessage);
        getAllTaskTodoList({ taskId, projectId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTaskTodoAdded, addTaskTodoData]);

  const doneCount = todos.filter((todo) => todo.isDone).length;
  const sortedTodos = [...todos].sort(
    (a, b) => Number(a.isDone) - Number(b.isDone)
  );

  return (
    <div className="todo-container">
      {todos.length > 0 && (
        <div className="todo-progress">
          <span>
            {doneCount} of {todos.length} done
          </span>
        </div>
      )}
      <div className="todo-scroll-section">
        {todos.length === 0 && !isAdding && (
          <div className="todo-empty">No items yet — add one below</div>
        )}
        {sortedTodos.map((todo) => (
          <div
            key={todo.taskTodoId}
            className={`todo-item ${todo.isDone ? "completed" : ""} ${
              editingId === todo.taskTodoId ? "is-editing" : ""
            }`}
          >
            <label>
              <input
                type="checkbox"
                checked={todo.isDone}
                onChange={() => handleToggleCheckbox(todo)}
              />
              {editingId === todo.taskTodoId ? (
                <input
                  type="text"
                  className="input-text"
                  value={editedText}
                  onChange={(e) => setEditedText(e.target.value)}
                  autoFocus
                />
              ) : (
                <span>{todo.todoText}</span>
              )}
            </label>
            <div className="todo-action">
              {editingId === todo.taskTodoId ? (
                <>
                  <div
                    className="save_icon"
                    onClick={() => handleSave(todo.taskTodoId)}
                  >
                    <Iconify icon="mdi:check" color="green" />
                  </div>
                  <div className="cancel_icon" onClick={handleCancel}>
                    <Iconify icon="mdi:close" color="red" />
                  </div>
                </>
              ) : (
                <div
                  className="edit_icon"
                  onClick={() => handleEdit(todo.taskTodoId, todo.todoText)}
                >
                  <Iconify icon="line-md:pencil" />
                </div>
              )}
              <div
                className="delete_icon"
                onClick={() => handleDelete(todo.taskTodoId)}
              >
                <Iconify icon="mingcute:delete-2-line" />
              </div>
            </div>
          </div>
        ))}

        {isAdding && (
          <div className="todo-item new-todo is-editing">
            <label>
              <input type="checkbox" disabled />
              <input
                className="input-text"
                type="text"
                value={newTodoText}
                onChange={(e) => setNewTodoText(e.target.value)}
                placeholder="Enter new todo..."
                autoFocus
              />
            </label>
            <div className="todo-action">
              <div className="save_icon" onClick={handleSaveNewTodo}>
                <Iconify icon="mdi:check" color="green" />
              </div>
              <div className="cancel_icon" onClick={handleCancel}>
                <Iconify icon="mdi:close" color="red" />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="add-todo-button" onClick={handleAddTodo}>
        <Iconify icon="mdi:plus" />
        <div className="add-todo-button-label">Add Todo Item</div>
      </div>
    </div>
  );
};

export default TodoTestLocal;
